import { LocalStorageService } from './../../core/services/local-storage.service';
import { StatService } from './../../core/services/stat-service/stat.service';
import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { CompanyService } from './../../core/services/company/company.service';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions,
  ApexNonAxisChartSeries,
} from 'ng-apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
export type ChartOptions = {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
};

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, OnDestroy  {
  /* ********************************** apexChart ********************************* */
  @ViewChild('chart') chart!: ChartComponent;
  public chartOptions!: any;
  id: any;
  liststat: any;
  typeintervenant: any;
  name:any;
  private refreshInterval: any;
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private statservice: StatService,
    private localStorageService: LocalStorageService,
      private companyService: CompanyService,
      private spinner: NgxSpinnerService,
  ) {}

  ngOnInit() {
    const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}')
    this.id = connectedUser?.company?.uuid
    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    this.getuserById();
    this.chartOptions = {
      series: [
        {
          name: 'basic',
          data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],
        },
      ],
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [
          'South Korea',
          'Canada',
          'United Kingdom',
          'Netherlands',
          'Italy',
          'France',
          'Japan',
          'United States',
          'China',
          'Germany',
        ],
      },
    };

    this.getStat();
    this.startAutoRefresh();
  }

  getStat() {
    this.statservice.getStatESN().subscribe({
      next: (response) => {
        if (response.data) {
          this.liststat = response.data;
        }
      },
      error: (error) => {
      },
    });
  }
getuserById() {
   
  this.spinner.show();
  this.companyService
    .getCompanydetail(this.id)
    .pipe(takeUntil(this.unsubscribeAll))
    .subscribe({
      next: (res) => {
        this.spinner.hide();
        this.name = res.data[0].name;
        console.log('testtt res.data',res?.data)
        
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      },
    });
// }
}
 // Refresh data every 20 seconds
  startAutoRefresh() {
    this.refreshInterval = setInterval(() => {
      this.getStat();
    }, 20000);
  }

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
}
